import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useReport } from '../../Data/Reports';
import { Sections } from '../../Components/Containers/Section';
import { PageLoading } from '../../Components/Loading';
import { useJobSummary } from '../../Data/Jobs';
import { useServices } from '../../Data/Services';
import BarPieTableChart from './Components/BarPieTableChart';

const Jobs = () => {
    const {report} = useReport('/jobs/report');
    const {summary} = useJobSummary(true);
    const {services} = useServices(true);

    return <>
        <TopBar left="/reports" title="Jobs" />
        <Page>
            {(report && summary) ? <Inner {...{summary, report, services}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({summary, report, services}) => {
    const getServiceName = (srv) => services ? (services.find(s => s.type === srv)?.title ?? srv) : srv;

    return <Sections>
        <BarPieTableChart title="Status"
            dataLabel="Jobs"
            groupingLabel="Status"
            subtitle="Count of jobs by status"
            labelValueData={summary.statuses.map(s => ({label: s.status, value: s.count}))}
        />
        <BarPieTableChart title="Services"
            dataLabel="Jobs"
            groupingLabel="Service"
            subtitle={`Count of jobs for each service.\nJobs with multiple services are counted once for each service`}
            labelValueData={report.services.map(s => ({label: getServiceName(s.service), value: s.count}))}
        />
        <BarPieTableChart title="Frequency"
            dataLabel="Jobs"
            groupingLabel="Frequency"
            subtitle={`Count of jobs by frequency`}
            labelValueData={report.frequencies.map(s => ({label: s.frequency, value: s.count}))}
        />
    </Sections>
}

export default Jobs;
